<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content container-fluid pb-0">
        <h5 class="mb-4">Staff Details</h5>
        <div
          class="d-flex justify-content-between align-items-center bg-light-300 p-3 rounded flex-wrap row-gap-3 mb-4"
        >
          <div class="d-flex align-items-center">
            <span class="avatar avatar-lg me-2">
              <img
                src="@/assets/img/profiles/avatar-36.jpg"
                class="rounded-circle"
                alt="user"
              />
            </span>
            <div>
              <div class="d-flex align-items-center">
                <h6 class="fs-14 me-2">Harvey Smith</h6>
                <span class="badge badge-success-100 d-flex align-items-center"
                  ><i class="ti ti-point-filled"></i>Active</span
                >
              </div>
              <span class="fs-12">Created on 14/02/2025</span>
            </div>
          </div>
          <div>
            <h6 class="fs-12 fw-medium">Phone</h6>
            <span class="fs-12">+1 245 646 5464</span>
          </div>
          <div>
            <h6 class="fs-12 fw-medium">Email</h6>
            <span class="fs-12">harvey@example.com</span>
          </div>
          <div>
            <h6 class="fs-12 fw-medium">Address</h6>
            <span class="fs-12">4412 Libby Street, Los Angeles, CA 90045</span>
          </div>
          <div>
            <h6 class="fs-12 fw-medium">No of Services</h6>
            <span class="fs-12">4</span>
          </div>
          <div>
            <h6 class="fs-12 fw-medium">No of Bookings</h6>
            <span class="fs-12">60</span>
          </div>
        </div>
        <h6 class="mb-4">Availability</h6>
        <div class="row">
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-15.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Computer Repair</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-17.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Steam Car Wash</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-19.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">House Cleaning</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-14.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Building Construction</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-16.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Interior Designing</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/service-provider/provider-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-23.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Plumbing Services</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-4 col-md-6">
            <div class="card shadow-none rounded">
              <div class="card-body">
                <div class="d-flex align-items-center flex-wrap row-gap-2">
                  <router-link
                    to="/provider/staff-details"
                    class="avatar avatar-xl flex-shrink-0 me-2"
                  >
                    <img
                      src="@/assets/img/providers/provider-18.jpg"
                      class="rounded"
                      alt="Img"
                    />
                  </router-link>
                  <div class="flex-fill">
                    <div class="d-flex justify-content-between">
                      <h6 class="fs-16 fw-medium">
                        <router-link to="/service-provider/provider-details">Electricals</router-link>
                      </h6>
                      <div class="user-icon d-inline-flex">
                        <a
                          href="javascript:void(0);"
                          class="me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-availability"
                          ><i class="ti ti-edit"></i
                        ></a>
                        <a href="javascript:void(0);" class=""
                          ><i class="ti ti-trash"></i
                        ></a>
                      </div>
                    </div>
                    <span class="fs-12 d-block mb-2">Days of Availability</span>
                    <div class="day-span d-flex gap-2">
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Mon</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Tue</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Wed</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Thr</span
                      >
                      <span
                        class="badge badge-info-transparent d-flex justify-content-center"
                        >Fri</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sat</span
                      >
                      <span class="badge badge-light d-flex justify-content-center"
                        >Sun</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <staff-details-modal></staff-details-modal>
  </div>
</template>
